export const ReferredTitle = "ReferredTitle";
export const ReferredFirstName = "ReferredFirstName";
export const ReferredLastName = "ReferredLastName";
export const EmployeeId = "EmployeeId";
export const JobTitle = "JobTitle";
export const DepartmentId = "DepartmentId";
export const PersonalEmailAddress = "PersonalEmailAddress";
export const EmailAddressConfirmed = "EmailAddressConfirmed";
export const IndividualAwareAccessPrivacyStatementConsent = "IndividualAwareAccessPrivacyStatementConsent";
export const IndividualAwareOfInviteConsent = "IndividualAwareOfInviteConsent";
export const IndividualAwareRequestAccessInWritingConsent = "IndividualAwareRequestAccessInWritingConsent";
